module.exports = __webpack_public_path__ + "static/media/no-this-is-patrick.b81483d9.mp3";